/**
 * （竞价）车辆审核
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, DatePicker, Input, Select, TreeSelect } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//车辆详情信息和审核
import AuctionAuditDetail from './AuctionAuditDetail';
//加载中遮罩
import Loading from '../../ui/Loading';
import PdfViewer from '../../ui/PdfViewer';
//维保报告查看
import MaintenanceReport from '../../mall/maintenance/MaintenanceReport';
//维保查询选择
import MaintenanceSelect from '../../mall/maintenance/MaintenanceSelect';
import messager from '../../ui/messager';
import { treeDataConversion, buildTree } from '../../ui/treeData';
//委托竞卖合同信息维护
import CommissionContractEdit from './CommissionContractEdit';
import { global_data } from '../../ui/auth';
const { Option } = Select;

class AuctionAuditIndex extends React.Component {

    columns = [{
        title: '创建人',
        dataIndex: 'nickname',
        width: '5%',
    }, {
        title: '车辆品牌型号',
        dataIndex: 'name',
        width: '15%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '提交时间',
        dataIndex: 'insertTime',
        width: '10%',
        // }, {
        //     title: '审核时间',
        //     dataIndex: 'auditTime',
        //     width: '10%',
    }, {
        title: '维保查询时间',
        dataIndex: 'report.insertTime',
        width: '10%',
    }, {
        title: '维保报告状态',
        dataIndex: 'report.status',
        width: '10%',
        format: { 0: "生成失败", 1: "已生成", 2: "生成中" }
    }, {
        title: '状态',
        dataIndex: 'statusStr',
        width: '5%',
    }, {
        title: '签章流程状态',
        dataIndex: 'signTaskStatus',
        format: { 9: "未发起签署", 0: "草稿", 1: "签署中", 2: "完成", 3: "撤销", 5: "过期", 7: "拒签" },
        width: '7%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("AUCTION_AUDIT_DETAIL")?
                <Tooltip title="车辆详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_AUDIT_CONTRACT")?
                <Tooltip title="维护委托竞卖合同信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.editCommissionContract.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_AUDIT_SIGN")?
                <Tooltip title="发起委托竞卖合同电子签章">
                    <Icon type="form" className="table-operate-icon" onClick={this.startContractSignFlow.bind(this, record)} />
                </Tooltip>
                :""}
                {
                        global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN")&&record.signTaskStatus === 2 ?
                        <Tooltip title="查看已签署完成的委托竞卖合同">
                            <Icon type="file-pdf" className="table-operate-icon" onClick={this.openPdf.bind(this, record, "signDoc")} />
                        </Tooltip> : ''
                }
                <Tooltip title="查看竞价车辆信息">
                    <Icon type="file-pdf" className="table-operate-icon" onClick={this.openPdf.bind(this, record, "vehicleInfo")} />
                </Tooltip>
                <Tooltip title="下载竞卖合同">
                    <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record)} />
                </Tooltip>
                {record.report != null && record.report.status !== 0 ?
                    <Tooltip title="车辆维保信息详情">
                        <Icon type="file-done" className="table-operate-icon" onClick={this.maintenanceReportDetail.bind(this, record)} />
                    </Tooltip> : ""
                }
                {global_data.authCode.includes("AUCTION_AUDIT_MT")?
                <Tooltip title="查询车辆维保信息">
                    <Icon type="file-search" className="table-operate-icon" onClick={this.findMaintenanceSuport.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AUCTION_AUDIT_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        loadingVisible: false,
        pdfVisible: false,

        reportVisible: false,
        reportData: {},

        maintenanceVisible: false,
        maintenanceData: {},
        clientSourceData: [],

        editContractVisible: false, //委托竞卖合同信息维护
        editContractData: {}, //委托竞卖合同信息维护
    };

    componentDidMount() {
        //获取客户来源数据
        http.post({
            url: '/dict/findDict',
            data: { category: "VEHICLE_CLIENT_SOURCE" },
            success: (res) => {
                res = res == null ? [] : res;
                //把客户来源字典重构为符合treeSelect格式要求的树形结构
                res = buildTree(res);
                treeDataConversion(res, false);
                //把res的code设置为name[code]，为了能用treeSelect的搜索
                this.handleTreeCode(res)
                this.setState({ clientSourceData: res });
            }
        });
    }

    handleTreeCode = (treeData) => {
        var stack = [];
        stack = stack.concat(treeData);
        while (stack != null && stack.length > 0) {
            let node = stack[0];
            stack.splice(0, 1);
            if (node.children != null) {
                stack = stack.concat(node.children);
            }
            //value设置为name[value]
            node.value = node.title + "[" + node.value + "]";
        }
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/auction/web/audit/query/detail',
            data: { id: info.id },
            success: (res) => {
                // this.transferData(res["vehicleImages"], "certificationImgs");
                // this.transferData(res["thumbnails"], "certificationImgs");
                this.setState({ editData: res, visible: true, loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    // 查看维保报告详细信息
    maintenanceReportDetail = (data, e) => {
        let info = data.report;
        if (info == null) return;
        this.setState({ loadingVisible: true });
        if (info.status === 2) {
            http.get({
                url: '/maintenance/findReport',
                data: { id: info.id },
                success: (res) => {
                    this.setState({ reportData: res, reportVisible: true, loadingVisible: false });
                }, error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        } else {
            this.setState({ reportData: info, reportVisible: true, loadingVisible: false });
        }
    }

    //查询维保支持的维保查询列表
    findMaintenanceSuport = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/maintenance/checkSupport',
            data: { vin: info.vin },
            success: (res) => {
                res.vin = info.vin;
                res.plateNo = info.plateNo;
                res.engineNo = info.engineNo;
                this.setState({ maintenanceData: res, maintenanceVisible: true, loadingVisible: false });
            }, error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }


    download = (info) => {
        this.setState({ loadingVisible: true });
        let url = "/auction/web/audit/download/contract";
        let fileName = "委托竞卖合同.docx";
        http.download({
            url: url,
            data: { "id": info.id },
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    delete = (id) => {
        messager.confirm("是否确定要删除这条车辆信息", () => {
            http.post({
                url: '/auction/web/audit/delete',
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData)
                    messager.notify("删除成功", "提示", 'success');
                },
                error: (res) => {
                    this.state.loadData(this.state.queryData)
                    messager.notify("删除失败", "提示", 'error');
                }
            });
        })
    }

    /**
     *  打开pdf文档，
     *  type 文档类型，vehicleInfo: 竞价车辆信息，signDoc:已签署完成的文档
     */ 
    openPdf = (info, type) => {
        this.setState({ loadingVisible: true });
        let url = "/auction/web/audit/download/vehicleinfo/pdf";
        if(type === "signDoc"){
            url = "/auction/web/audit/download/finishedContract/pdf";
        }
        this.refs["pdfViewer"].loadFile({
            url: url,
            data: { id: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, pdfVisible: true });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //修改委托竞卖合同信息
    editCommissionContract = (info) => {
        http.get({
            url: '/auction/web/audit/getCommissionContract',
            data: {
                vehicleId: info.id
            },
            success: (res) => {
                let editContractData = res == null ? {} : res;
                editContractData.vehicleId = info.id;
                editContractData.clientName = info.owner;
                editContractData.clientAddr = info.ownerAddress;
                this.setState({ editContractVisible: true, editContractData });
            }
        });
    }

    //发起委托竞卖合同电子签章流程
    startContractSignFlow = (info) => {
        let msg = "是否确定发起该电子签署流程？";
        if(info.status === "DRAFT" || info.status ==="UNVERIFYING" || info.status === "VERIFY_FAIL"){
            msg = "此车辆还未通过审核，是否确定发起电子签署流程？";
        }
        messager.confirm(msg, () => {
            this.setState({ loadingVisible: true });
            http.post({
                url: '/auction/web/audit/createSignFlow',
                data: { vehicleId: info.id },
                success: (res) => {
                    messager.notify("发起成功，请注意查收短信！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }

    transferData = (res, field) => {
        let data = res[field];
        for (let key in data) {
            res[field + "." + key] = data[key];
        }
        delete res[field];
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (field, res) => {
        let queryData = this.state.queryData;
        queryData[field] = res;
        if (field === "clientSource" && res) {
            let start = res.indexOf("[");
            queryData[field] = res.substring(start + 1, res.length - 1);
        }
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keywords = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆关键字或车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <Select placeholder="车辆状态" onChange={this.onSelect.bind(this, "status")} allowClear style={{ width: '150px', margin: '0 10px' }}>
                                    <Option value="DRAFT">草稿</Option>
                                    <Option value="UNVERIFYING">未审核</Option>
                                    <Option value="VERIFYED">已审核</Option>
                                    <Option value="VERIFY_FAIL">审核失败</Option>
                                </Select>
                                <TreeSelect placeholder="客户来源" multiple={false} onChange={this.onSelect.bind(this, "clientSource")} allowClear
                                    treeData={this.state.clientSourceData} treeDefaultExpandAll={false} showSearch={true} style={{ width: '150px', margin: '0 10px' }} />
                                {/* <DictSelect category="VEHICLE_AUCTION_STATUS" allowClear={true} onChange={this.onSelect} style={{ width: '150px', margin: '0 10px' }} /> */}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auction/web/audit/query/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <AuctionAuditDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <PdfViewer
                    visible={this.state.pdfVisible}
                    onCancel={() => { this.setState({ pdfVisible: false }) }}
                    ref="pdfViewer"
                />
                <MaintenanceReport
                    visible={this.state.reportVisible}
                    onCancel={() => this.setState({ reportVisible: false })}
                    editData={this.state.reportData}
                />
                <MaintenanceSelect
                    visible={this.state.maintenanceVisible}
                    editData={this.state.maintenanceData}
                    onCancel={() => this.setState({ maintenanceVisible: false })}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <CommissionContractEdit
                    visible={this.state.editContractVisible}
                    editData={this.state.editContractData}
                    onCancel={() => this.setState({ editContractVisible: false })}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />
            </div>
        )
    }
}

export default AuctionAuditIndex;